@if (showActionGroup && toggleActionGroup) {
  <sh-action-group [actionGroup]="toggleActionGroup" [childComponentClasses]="childComponentClasses">
  </sh-action-group>
}
